import Accessor from "./Accessor";
import PrefixBorder from "./PrefixBorder";
import Prefix from "./Prefix";
export default {
  Accessor: Accessor,
  PrefixBorder: PrefixBorder,
  Prefix: Prefix
};